

// // {
// //   `Product list for category: ${params?.categoryName}` && (
// //     <CategorySearchDisplay productsCategory={params?.categoryName} heading={"Recommended Products"}/>
// //   )
  
// // }


// import React, { useEffect, useState } from 'react'
// import { useLocation, useNavigate, useParams } from 'react-router-dom'
// import productCategory from '../../helpers/productCategory'
// import ViewSearch from '../../components/ViewSearch/ViewSearch'
// import { summaryApi } from '../../common'

// function CategoryProduct() {
//   const location = useLocation()
//   const navigate = useNavigate()
//   const [data, setData] = useState([])
//   const [loading, setLoading] = useState(false)
//   const [sortBy, setSortBy] = useState("")

//   const getUrlCategories = () => {
//     const searchParams = new URLSearchParams(location.search)
//     return searchParams.getAll('category').filter(Boolean)
//   }

//   const [selectCategory, setSelectCategory] = useState(
//     Object.fromEntries(getUrlCategories().map(cat => [cat, true]))
//   )
//   const [filterCategoryList, setFilterCategoryList] = useState(getUrlCategories())

//   const fetchData = async () => {
//     try {
//       setLoading(true)
//       const response = await fetch(summaryApi.filterProducts.url, {
//         method: summaryApi.filterProducts.method,
//         credentials: "include",
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           productsCategory: filterCategoryList
//         })
//       })
//       const responseData = await response.json()
//       setLoading(false)
//       setData(responseData?.data || [])
//     } catch (error) {
//       console.error("Error fetching products:", error)
//       setLoading(false)
//     }
//   }
  
//   const handleSelectCategory = (e) => {
//     const {value, checked} = e.target
//     setSelectCategory((prev) => ({
//      ...prev,
//       [value]: checked
//     }))   
//   }

//   useEffect(() => {
//     fetchData()
//   }, [filterCategoryList])

//   useEffect(() => {
//     const arrayOfCategory = Object.keys(selectCategory)
//       .filter(item => selectCategory[item])
    
//     setFilterCategoryList(arrayOfCategory)

//     const urlSearchParams = new URLSearchParams()
//     arrayOfCategory.forEach(category => {
//       urlSearchParams.append('category', category)
//     })

//     const newUrl = arrayOfCategory.length 
//       ? `/product-category?${urlSearchParams.toString()}` 
//       : '/product-category'

//     navigate(newUrl, { replace: true })
//   }, [selectCategory, navigate])

//   const handleOnChangeSortBy = (e) => {
//     const { value } = e.target
//     setSortBy(value)

//     // just create a new sorted array instead of mutating the state directly
//     const sortedData = [...data]
    
//     if (value === 'lowToHigh') {
//       sortedData.sort((a, b) => a.productPrice - b.productPrice)
//     }
//     if (value === 'highToLow') {
//       sortedData.sort((a, b) => b.productPrice - a.productPrice)
//     }

//     setData(sortedData)
//   }

//   return (
//     <div className='container mx-auto p-4'>
//          <div className='hidden lg:grid grid-cols-[200px,1fr]'>
//             <div className='bg-slate-200 p-2 min-h-[calc(100vh-120px)] overflow-y-scroll'>
//                 <div className=''>
//                    <h3 className='text-base uppercase font-medium text-slate-800 border-b pb-1 border-slate-400'>Sort by</h3>

//                    <form className='text-sm flex flex-col gap-2 py-2'>
//                        <div className='flex items-center gap-3'>
//                           <input 
//                             type='radio' 
//                             name='sortBy' 
//                             value='lowToHigh'
//                             onChange={handleOnChangeSortBy}
//                             checked={sortBy === 'lowToHigh'}
//                           />
//                           <label>Price: Low to High</label>
//                        </div>
//                        <div className='flex items-center gap-3'>
//                           <input 
//                             type='radio' 
//                             name='sortBy' 
//                             value='highToLow'
//                             onChange={handleOnChangeSortBy}
//                             checked={sortBy === 'highToLow'}
//                           />
//                           <label>Price: High to Low</label>
//                        </div>
//                    </form>
//                 </div>

//                 <div className=''>
//                    <h3 className='text-base uppercase font-medium text-slate-800 border-b pb-1 border-slate-400'>Category</h3>

//                    <form className='text-sm flex flex-col gap-2 py-2'>
//                        {
//                         productCategory.map((item, index) => (
//                              <div key={index} className='flex items-center gap-3'>
//                                 <input 
//                                     type='checkbox' 
//                                     name={`category-${item.value}`}   
//                                     value={item?.value} 
//                                     id={item?.value} 
//                                     checked={!!selectCategory[item?.value]}  
//                                     onChange={handleSelectCategory}
//                                 />
//                                 <label htmlFor={item?.value}>
//                                   {item?.label}
//                                 </label>
//                              </div>
//                           )
//                         )
//                        }
//                    </form>
//                 </div>
//             </div>

//             <div className='px-4'>
//               <p className='font-medium text-slate-800 text-lg my-2'>Search Results : {data?.length}</p>
//               <div className='min-h-[calc(100vh-120px)] overflow-y-scroll max-h-[calc(100vh-120px)]'>
//                {
//                 data.length !== 0 && (
//                   <ViewSearch data={data}/>
//                 )
//                }
//               </div>
//             </div>
//          </div>
//     </div>
//   )
// }

// export default CategoryProduct


import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import productCategory from '../../helpers/productCategory'
import ViewSearch from '../../components/ViewSearch/ViewSearch'
import { summaryApi } from '../../common'
import { useTheme } from '../../components/Theme/ThemeProvider'
import { FaFilter, FaX } from 'react-icons/fa6'
import { ArrowLeft } from 'lucide-react'
import { authFetch } from '../../helpers/authFetch'

function CategoryProduct() {
  const location = useLocation()
  const navigate = useNavigate()
  const { colors } = useTheme()
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [sortBy, setSortBy] = useState("")
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false)

  const getUrlCategories = () => {
    const searchParams = new URLSearchParams(location.search)
    return searchParams.getAll('category').filter(Boolean)
  }

  const [selectCategory, setSelectCategory] = useState(
    Object.fromEntries(getUrlCategories().map(cat => [cat, true]))
  )
  const [filterCategoryList, setFilterCategoryList] = useState(getUrlCategories())

  const fetchData = async () => {
    try {
      setLoading(true)
      const response = await authFetch(summaryApi.filterProducts.url, {
        method: summaryApi.filterProducts.method,
        
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          productsCategory: filterCategoryList
        })
      })
      const responseData = await response.json()
      setLoading(false)
      setData(responseData?.data || [])
    } catch (error) {
      console.error("Error fetching products:", error)
      setLoading(false)
    }
  }
  
  const handleSelectCategory = (e) => {
    const {value, checked} = e.target
    setSelectCategory((prev) => ({
     ...prev,
      [value]: checked
    }))   
  }

  useEffect(() => {
    fetchData()
  }, [filterCategoryList])

  useEffect(() => {
    const arrayOfCategory = Object.keys(selectCategory)
      .filter(item => selectCategory[item])
    
    setFilterCategoryList(arrayOfCategory)

    const urlSearchParams = new URLSearchParams()
    arrayOfCategory.forEach(category => {
      urlSearchParams.append('category', category)
    })

    const newUrl = arrayOfCategory.length 
      ? `/product-category?${urlSearchParams.toString()}` 
      : '/product-category'

    navigate(newUrl, { replace: true })
  }, [selectCategory, navigate])

  const handleOnChangeSortBy = (e) => {
    const { value } = e.target
    setSortBy(value)

    const sortedData = [...data]
    
    if (value === 'lowToHigh') {
      sortedData.sort((a, b) => a.productPrice - b.productPrice)
    }
    if (value === 'highToLow') {
      sortedData.sort((a, b) => b.productPrice - a.productPrice)
    }

    setData(sortedData)
  }

  const goBack = ()=>{
    navigate(-1)
  }

  // Render filter sidebar for mobile and desktop
  const renderFilterSidebar = (isMobile = false) => (
    <div 
      className={`
        ${isMobile 
          ? 'fixed inset-0 z-50 p-4 overflow-y-auto backdrop-blur-sm' 
          : 'hidden lg:block min-h-[calc(100vh-120px)] overflow-y-scroll rounded-lg'}
        shadow-lg transition-all duration-300
      `}
      style={{
        backgroundColor: isMobile ? `${colors.bgSecondary}dd` : colors.bgSecondary,
        border: `1px solid ${colors.border}`
      }}
    >
   
      {isMobile && (
        <div className='flex justify-between items-center mb-4'>
          <h2 
            className='text-xl font-bold'
            style={{ color: colors.text }}
          >
            Filters
          </h2>
          <button 
            onClick={() => setMobileFilterOpen(false)}
            className='rounded-full p-2 transition-all hover:scale-110'
            style={{ 
              backgroundColor: colors.bgTertiary,
              color: colors.text
            }}
          >
            <FaX size={18} />
          </button>
        </div>
      )}

      {/* Sort By Section */}
      <div className='mb-6 p-4'>
        <h3 
          className='text-base uppercase font-bold border-b pb-2 mb-3'
          style={{ 
            color: colors.primary,
            borderColor: colors.border
          }}
        >
          Sort by
        </h3>
        <form className='text-sm flex flex-col gap-3'>
          <div className='flex items-center gap-3'>
            <input 
              type='radio' 
              name='sortBy' 
              value='lowToHigh'
              onChange={handleOnChangeSortBy}
              checked={sortBy === 'lowToHigh'}
              className='w-4 h-4 cursor-pointer'
              style={{ accentColor: colors.primary }}
            />
            <label 
              style={{ color: colors.text }}
              className='cursor-pointer'
            >
              Price: Low to High
            </label>
          </div>
          <div className='flex items-center gap-3'>
            <input 
              type='radio' 
              name='sortBy' 
              value='highToLow'
              onChange={handleOnChangeSortBy}
              checked={sortBy === 'highToLow'}
              className='w-4 h-4 cursor-pointer'
              style={{ accentColor: colors.primary }}
            />
            <label 
              style={{ color: colors.text }}
              className='cursor-pointer'
            >
              Price: High to Low
            </label>
          </div>
        </form>
      </div>

      {/* Category Section */}
      <div className='p-4'>
        <h3 
          className='text-base uppercase font-bold border-b pb-2 mb-3'
          style={{ 
            color: colors.primary,
            borderColor: colors.border
          }}
        >
          Category
        </h3>
        <form className='text-sm flex flex-col gap-3'>
          {productCategory.map((item, index) => (
            <div key={index} className='flex items-center gap-3'>
              <input 
                type='checkbox' 
                name={`category-${item.value}`}   
                value={item?.value} 
                id={item?.value} 
                checked={!!selectCategory[item?.value]}  
                onChange={handleSelectCategory}
                className='w-4 h-4 cursor-pointer'
                style={{ accentColor: colors.primary }}
              />
              <label 
                htmlFor={item?.value}
                style={{ color: colors.text }}
                className='cursor-pointer'
              >
                {item?.label}
              </label>
            </div>
          ))}
        </form>
      </div>
    </div>
  )

  return (
    <div 
      className='container mx-auto p-4 mt-20'
      style={{ backgroundColor: colors.bg, minHeight: '100vh' }}
    >
      {/* Mobile Filter Toggle */}
      <div className='lg:hidden flex justify-between items-center mb-6'>
        <p 
          className='font-bold text-lg'
          style={{ color: colors.text }}
        >
          Results: {data?.length}
        </p>
        <button 
          onClick={() => setMobileFilterOpen(true)}
          className='flex items-center gap-2 p-3 rounded-lg transition-all hover:scale-105'
          style={{
            backgroundColor: colors.primary,
            color: 'white'
          }}
        >
          <FaFilter />
          Filters
        </button>
      </div>
         <button
        onClick={goBack}
        className='mb-6 px-4 py-2 rounded-lg font-medium transition-all hover:scale-105'
        style={{
          backgroundColor: colors.primary,
          color: 'white'
        }}
      >
         Go Back <ArrowLeft className="inline-block w-4 h-4 ml-1" />
      </button>

      {/* Mobile Filter Modal */}
      {mobileFilterOpen && (
        <div className='lg:hidden'>
          {renderFilterSidebar(true)}
        </div>
      )}

      {/* Main Content Layout */}
      <div className='grid grid-cols-1 lg:grid-cols-[250px,1fr] gap-6'>
        
        {/* Desktop Sidebar */}
        {renderFilterSidebar()}

        {/* Product List */}
        <div>
          <p 
            className='hidden lg:block font-bold text-lg mb-6'
            style={{ color: colors.text }}
          >
            Search Results: {data?.length}
          </p>
          <div className='min-h-[calc(100vh-200px)]'>
            {data.length !== 0 && (
              <ViewSearch data={data}/>
            )}
            {data.length === 0 && (
              <div 
                className='text-center py-16 rounded-lg'
                style={{
                  backgroundColor: colors.bgSecondary,
                  color: colors.textSecondary
                }}
              >
                <p className='text-lg font-medium'>No products found</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CategoryProduct